export default __webpack_public_path__ + "static/media/packages.31198c79.svg";